import { PATH } from './constants/router'
import AutomatedTrafficFineNotificationPayment from './page/AutomatedTrafficFineNotificationPayment'
import AutomatedTrafficFineNotificationSuccess from './page/AutomatedTrafficFineNotificationSuccess'
import AutomatedTrafficFineNotificationPaymentSuccess from './page/AutomatedTrafficFineNotificationPaymentSuccess'
import TrafficFineRedirectHandler from './page/TrafficFineRedirectHandler'
import SplashScreen from './page/SplashScreen'
import TrafficFineCheckConsent from './page/TrafficFineCheckConsent'
import TrafficFineLookupV2 from './page/TrafficFineLookup'
import TrafficFineCheckResultV2 from './page/TrafficFineCheckResult'
import TrafficFineNotificationServices from './page/TrafficFineNotificationServices'
import TrafficFineNotificationVehicles from './page/TrafficFineNotificationVehicles'
import TrafficFinePackageInfo from './page/TrafficFinePackageInfo'
import TrafficFineRegistrationManagement from './page/TrafficFineRegistrationManagement'
import TrafficFineRegistrationManagementFirstTime from './page/TrafficFineRegistrationManagementFirstTime'
import TrafficFineReferral from './page/TrafficFineReferral'
import TrafficFinePhoneAuth from './page/TrafficFinePhoneAuth'
import FAQ from './page/TrafficFineFAQ'
import TrafficFineTermsOfServicePayment from './page/TrafficFineTermsOfServicePayment'
import BIDVLogin from './page/BIDVLogin'

export const ROUTERS = {
  splash: {
    path: PATH.HOME,
    component: TrafficFineLookupV2
  },
  trafficFineLookupV2: {
    path: PATH.TRAFFIC_FINE_LOOKUP,
    component: TrafficFineLookupV2
  },
  trafficFineCheckResultV2: {
    path: PATH.TRAFFIC_FINE_CHECK_RESULT,
    component: TrafficFineCheckResultV2
  },
  trafficFineServices: {
    path: PATH.TRAFFIC_FINE_SERVICES,
    component: TrafficFineNotificationServices
  },
  trafficFineVehicles: {
    path: PATH.TRAFFIC_FINE_VEHICLES,
    component: TrafficFineNotificationVehicles
  },
  automatedTrafficFineNotificationPayment: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
    component: AutomatedTrafficFineNotificationPayment
  },
  automatedTrafficFineNotificationPaymentSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT_SUCCESS,
    component: AutomatedTrafficFineNotificationPaymentSuccess
  },
  automatedTrafficFineNotificationRedirectHandler: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_REDIRECT_HANDLER,
    component: TrafficFineRedirectHandler
  },
  automatedTrafficFineNotificationSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS,
    component: AutomatedTrafficFineNotificationSuccess
  },
  trafficFinePackageInfo: {
    path: PATH.TRAFFIC_FINE_PACKAGE_INFO,
    component: TrafficFinePackageInfo
  },
  trafficFineRegistrationManagement: {
    path: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
    component: TrafficFineRegistrationManagement
  },
  trafficFineRegistrationManagementFirstTime: {
    path: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME,
    component: TrafficFineRegistrationManagementFirstTime
  },
  trafficFineFaq: {
    path: PATH.TRAFFIC_FINE_FAQ,
    component: FAQ
  },
  trafficFineConsent: {
    path: PATH.TRAFFIC_FINE_CONSENT,
    component: TrafficFineCheckConsent
  },
  trafficFineReferral: {
    path: PATH.TRAFFIC_FINE_REFERRAL,
    component: TrafficFineReferral
  },
  trafficFinePhoneAuth: {
    path: PATH.TRAFFIC_FINE_PHONE_AUTH,
    component: TrafficFinePhoneAuth
  },
  trafficFineTermsOfServicePayment: {
    path: PATH.TRAFFIC_FINE_TERMS_OF_SERVICE_PAYMENT,
    component: TrafficFineTermsOfServicePayment
  },
  bidvLogin: {
    path: PATH.BIDV_LOGIN,
    component: BIDVLogin
  }
}
